import type { LogLevel } from '@types';
import type React from 'react';

export const toastConfigByLevel: Record<
  LogLevel,
  {
    className?: string;
    style?: React.CSSProperties;
  }
> = {
  info: {
    style: {
      backgroundColor:
        'color-mix(in oklch, var(--color-primary) 55%, transparent)',
      color: 'var(--color-primary-foreground)',
      borderColor: 'var(--color-primary)',
    },
  },
  warning: {
    style: {
      backgroundColor:
        'color-mix(in oklch, var(--color-warning) 65%, transparent)',
      color: 'var(--color-warning-foreground)',
      borderColor: 'var(--color-warning)',
    },
  },
  success: {
    style: {
      backgroundColor:
        'color-mix(in oklch, var(--color-success) 65%, transparent)',
      color: 'var(--color-success-foreground)',
      borderColor: 'var(--color-success)',
    },
  },
  error: {
    style: {
      backgroundColor:
        'color-mix(in oklch, var(--color-error) 65%, transparent)',
      color: 'var(--color-error-foreground)',
      borderColor: 'var(--color-error)',
    },
  },
};
